import { Route, Routes } from 'react-router-dom';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import Security from './pages/Security';
import TermsOfService from './pages/TermsOfService';
// Solution pages
import CertificationPackage from './pages/solutions/CertificationPackage';
import ChargebackHealthCheck from './pages/solutions/ChargebackHealthCheck';
import ClaimHealthCheck from './pages/solutions/ClaimHealthCheck';
import CmsPortalRpa from './pages/solutions/CmsPortalRpa';
import Dashboards from './pages/solutions/Dashboards';
import DataMigration from './pages/solutions/DataMigration';
import DisputePortal from './pages/solutions/DisputePortal';
import Dsa from './pages/solutions/Dsa';
import Duplicates340B from './pages/solutions/Duplicates340B';
import FairValueLetters from './pages/solutions/FairValueLetters';
import FormularyManagement from './pages/solutions/FormularyManagement';
import GlReconciliation from './pages/solutions/GlReconciliation';
import GpoRosterManagement from './pages/solutions/GpoRosterManagement';
import GtnForecasting from './pages/solutions/GtnForecasting';
import InvoiceSubmissionRpa from './pages/solutions/InvoiceSubmissionRpa';
import MfpEffectuation from './pages/solutions/MfpEffectuation';
import NumberMatching from './pages/solutions/NumberMatching';
import PriceReallocation from './pages/solutions/PriceReallocation';

// Articles pages
import RequireAuth from './auth/RequireAuth';
import Articles from './pages/Articles';
import MfpGp from './pages/articles/MfpGp06-20-25';
import MfpGtn from './pages/articles/MfpGtn07-07-25 ';
import MfpLts from './pages/articles/MfpLts06-10-25';
import ResponsibleAiAdoption from './pages/articles/ResponsibleAiAdoption10-04-26';
import AmplifyingPharmaTech from './pages/articles/AmplifyingPharmaTech10-04-26';
import Assessment from './pages/Assessment';
import Dispute from './pages/Dispute';
import McdMap from './pages/McdMap';
import Privacy from './pages/Privacy';
import RebateModel from './pages/RebateModel';
import Trial from './pages/Trial';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/trial" element={<Trial />} />
      <Route path="/rebate-model" element={<RebateModel />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/dispute" element={<Dispute />} />
      <Route path="/security" element={<Security />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/map"
        element={
          <RequireAuth>
            <McdMap />
          </RequireAuth>
        }
      />

      <Route path="/solutions/Dsa" element={<Dsa />} />
      <Route
        path="/solutions/InvoiceSubmissionRpa"
        element={<InvoiceSubmissionRpa />}
      />
      <Route
        path="/solutions/GpoRosterManagement"
        element={<GpoRosterManagement />}
      />
      <Route path="/solutions/Duplicates340B" element={<Duplicates340B />} />
      <Route path="/solutions/DisputePortal" element={<DisputePortal />} />
      <Route path="/solutions/GtnForecasting" element={<GtnForecasting />} />
      <Route
        path="/solutions/PriceReallocation"
        element={<PriceReallocation />}
      />
      <Route
        path="/solutions/GlReconciliation"
        element={<GlReconciliation />}
      />
      <Route path="/solutions/CmsPortalRpa" element={<CmsPortalRpa />} />
      <Route
        path="/solutions/CertificationPackage"
        element={<CertificationPackage />}
      />
      <Route path="/solutions/MfpEffectuation" element={<MfpEffectuation />} />
      <Route
        path="/solutions/FormularyManagement"
        element={<FormularyManagement />}
      />
      <Route
        path="/solutions/ChargebackHealthCheck"
        element={<ChargebackHealthCheck />}
      />
      <Route
        path="/solutions/ClaimHealthCheck"
        element={<ClaimHealthCheck />}
      />
      <Route path="/solutions/NumberMatching" element={<NumberMatching />} />
      <Route path="/solutions/DataMigration" element={<DataMigration />} />
      <Route path="/solutions/Dashboards" element={<Dashboards />} />
      <Route
        path="/solutions/FairValueLetters"
        element={<FairValueLetters />}
      />

      <Route path="/articles" element={<Articles />} />
      <Route path="/articles/MfpLts" element={<MfpLts />} />
      <Route path="/articles/MfpGp" element={<MfpGp />} />
      <Route path="/articles/MfpGtn" element={<MfpGtn />} />
      <Route
        path="/articles/ResponsibleAiAdoption"
        element={<ResponsibleAiAdoption />}
      />
      <Route
        path="/articles/AmplifyingPharmaTech"
        element={<AmplifyingPharmaTech />}
      />
    </Routes>
  );
}
